define([
    'text!WebCommon/modal/cart-tip.html',
    'WebCommon/mixin/modal',
    'WebCommon/modal/modal',

    'css!WebCommon/modal/cart-tip.css'
], function(
    tpl,
    ModalMixin,
    Modal
){
    return {
        template: tpl,
        mixins: [ModalMixin],
        data: function(){
            return {info:{}}

        },
        watch: {
            'modalData.info': function(value){
                this.info = value;
            }
        },
        methods: {

            login: function(from){
                Modal.showMemberLoginModal(from);
            },
            goNeedAuthPage: function(link){
                if (FNJISite.user.login=="1"){
                    window.location.href = link;
                } else {
                    this.login(link);
                }
            },
        },
        mounted: function(){
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ../common/modal/cart-tip.js
// module id = 110
// module chunks = 0